




















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { firestore } from "@/scripts/firebase";
import { Message, JinroPlayerDocument } from "@/services/datatypes";
import { ToastProgrammatic as Toast } from "buefy";
import { chatSentTimeSince } from "@/utils/utils";
import {
  TOAST_DURATION_MILLISECONDS,
  PUBLIC_VIEWER_POSTER_NAME_SUFFIX,
  CHAT_MAX_GET_NUMBER
} from "@/services/constants";
import HandlePostChat from "./HandlePostChat/HandlePostChat.vue";
import ChatMessage from "@/components/shared/ChatMessage.vue";

@Component({
  components: {
    HandlePostChat,
    ChatMessage
  }
})
export default class Chat extends Vue {
  @Prop() readonly cardHeader!: string;
  @Prop() readonly refChatroom!: firebase.firestore.CollectionReference;
  @Prop() readonly submittable!: boolean;
  @Prop() readonly willBePublic!: boolean;
  messages: Array<Message> = [];
  detacher?: firebase.Unsubscribe;
  isOkToToast = false;

  get messagesWithType(): Array<any> {
    return this.messages.map(message => {
      let params = {};
      if (message.playerId === this.$route.params.jinroPlayerId) {
        params = {
          isMe: true,
          playerName: message.playerName + " (you)"
        };
      } else {
        params = { isMe: false };
      }
      return {
        ...message,
        ...params
      };
    });
  }

  get suffix(): string {
    return PUBLIC_VIEWER_POSTER_NAME_SUFFIX;
  }

  get chatMaxNumber(): string {
    return String(CHAT_MAX_GET_NUMBER);
  }

  chatName(message: Message): string {
    if (!message.fromPublicViewing) {
      return message.playerName;
    }
    return message.fromPublicViewing
      ? message.playerName + this.suffix
      : message.playerName;
  }

  async created() {
    this.detacher = this.refChatroom
      .orderBy("timeCreated", "desc")
      .limit(CHAT_MAX_GET_NUMBER)
      .onSnapshot(snapshot => {
        snapshot.docChanges().forEach(change => {
          if (change.type === "added") {
            if (this.isOkToToast) {
              const newMessage = change.doc.data() as Message;
              newMessage.id = change.doc.id;
              if (newMessage.playerId === this.$route.params.jinroPlayerId) {
                return;
              }
              this.toastNewMessage(newMessage);
            }
          }
        });

        this.messages = snapshot.docs.map(doc => {
          return Object.assign(doc.data(), { id: doc.id }) as Message;
        });
        if (this.messages.length > 0) {
          this.isOkToToast = true;
        }
      });
  }
  destroyed() {
    this.detacher && this.detacher();
  }

  toastNewMessage(newMessage: Message) {
    Toast.open({
      duration: TOAST_DURATION_MILLISECONDS,
      type: "is-white",
      position: "is-bottom-right",
      queue: false,
      message: newMessage.message + "<br/>from " + this.chatName(newMessage)
    });
  }
}
